import axios from 'axios'
import { formatAxiosError } from './apiErrors'
const URL = 'https://rentalios-management-helxajom3a-uc.a.run.app/api'
// const URL = "http://localhost:3000/api"
const apiKey = 'db31a33d-9efb-4112-a246-6e60cbd779a8'

async function getRooms({
  page = 1,
  perPage = 100,
  propertyIds = '',
  occupancy = ''
}) {
  try {
    const response = await axios({
      method: 'GET',
      url: `${URL}/rooms/${page}/${perPage}`,
      params: {
        key: apiKey,
        propertyId: propertyIds,
        occupancy: occupancy
      }
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return { error: formatAxiosError(error) }
  }
}

async function getUplistingDiscounts() {
  try {
    const response = await axios({
      method: 'GET',
      url: `${URL}/rooms/uplisting/discounts`,
      params: {
        key: apiKey
      }
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return { error: formatAxiosError(error) }
  }
}

export default {
  getRooms,
  getUplistingDiscounts
}
